module.exports = __webpack_public_path__ + "img/checkItem.e82d05c4.svg";